export default "__VITE_ASSET__C41ivWVq__"